<template>
	<drawer
			title="Edit password"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<field
				:classError="$v.password.$error"
				margin="0 0 10px 0"
				width="300px"
				label="Password"
				type="password"
				placeholder="Enter password"
				@updateInput="onInput($event, 'password')"
				:setInputValue="password"
				is-required
				is-pass
		></field>
		<field
				:classError="$v.repeatPassword.$error"
				margin="0"
				width="300px"
				type="password"
				label="Confirm password"
				placeholder="Confirm password"
				@updateInput="onInput($event, 'repeatPassword')"
				:setInputValue="repeatPassword"
				is-required
				is-pass
		></field>
	</drawer>
</template>

<script>
import { mapActions } from "vuex";
// shared
// helpers
import { getErrorMessage, REG_EXP, TEXT_ERRORS } from "@/components/Profile/ProfileEditPassword/helper";
// import sha256 from 'sha256';
// validations
import { validationMixin } from "vuelidate";
import { minLength, required, sameAs } from "vuelidate/lib/validators";
import Drawer from "@/shared/Drawer/Drawer.vue";
const mustBeValid = (value) => REG_EXP.test(value);
export default {
	name: "ProfileEditPassword",
	mixins: [ validationMixin ],
	components: {
		Drawer,
	},
	data: () => ({
		password: null,
		repeatPassword: null,
	}),
	validations: {
		password: {
			minLength: minLength(6),
			required, // если поле обязательно
			mustBeValid // проверка по новой регулярке
		},
		repeatPassword: {
			required,
			sameAsPassword: sameAs('password')
		},
	},
	methods: {
		...mapActions([ 'setAlert', 'onEditPassword' ]),
		onInput({ value }, key) {
			this[key] = value;
		},
		onClose() {
			this.$emit('closeDrawer');
		},
		getValidMessage() {
			const errorsText = [];
			if (!this.$v.password.mustBeValid) {
				errorsText.push(TEXT_ERRORS.MUST_BE_VALID);
			}

			if (!this.$v.repeatPassword.sameAsPassword) {
				errorsText.push(TEXT_ERRORS.PASSWORD_MATCH);
			}

			if (!this.password && !this.repeatPassword) {
				errorsText.push(TEXT_ERRORS.FILL);
			}

			const message = getErrorMessage(errorsText);
			if (message) this.setAlert( { type: 'error', message });
		},
		async onSave() {
			this.$v.$touch();
			this.getValidMessage();

			if (!this.$v.$error) {
				//sha256(this.password)
				const { status } = await this.onEditPassword({ password: this.password });
				if (status) {
					this.setAlert( { type: 'success', message: 'Password changed' });
					this.onClose();
				} else {
					this.setAlert( { type: 'error', message: 'Password didn\'t change' });
				}
			}
		}
	}
};
</script>
